export default __webpack_public_path__ + "static/media/logo.11e067ef.png";